import React from 'react';
import {
  ExpandedPanel,
  PanelGrid,
  PanelField,
  PanelLabel,
  PanelValue,
  PanelLink,
  PanelSection,
  PanelSectionTitle,
  ParticipantList,
  ParticipantChip,
} from '../LiveMeetingsDashboard.styles';

function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

function formatCountdown(iso) {
  if (!iso) return null;
  const ms = new Date(iso) - Date.now();
  if (ms < 0) return 'Deadline has passed';
  const mins = Math.floor(ms / 60000);
  if (mins < 60) return `${mins}m remaining`;
  const hrs = Math.floor(mins / 60);
  return `${hrs}h ${mins % 60}m remaining`;
}

export default function ApprovalPanel({ item }) {
  const { approvalData, meetingTitle, meetingUrl, scheduledStartTime, participantEmails } = item;

  const organizer = approvalData?.requestedBy || approvalData?.userId || '—';
  const deadline  = approvalData?.approvalDeadline;
  const countdown = formatCountdown(deadline);

  return (
    <ExpandedPanel>
      <PanelGrid $cols={3}>
        <PanelField>
          <PanelLabel>Meeting</PanelLabel>
          <PanelValue>{meetingTitle || '(No title)'}</PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Scheduled Start</PanelLabel>
          <PanelValue>{formatDateTime(scheduledStartTime)}</PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Approval Deadline</PanelLabel>
          <PanelValue>
            {formatDateTime(deadline)}
            {countdown && (
              <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 600, color: deadline && new Date(deadline) < Date.now() ? '#991b1b' : '#92400e' }}>
                ({countdown})
              </span>
            )}
          </PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Requested by</PanelLabel>
          <PanelValue>{organizer}</PanelValue>
        </PanelField>

        <PanelField>
          <PanelLabel>Request ID</PanelLabel>
          <PanelValue style={{ fontFamily: 'monospace', fontSize: 12 }}>{approvalData?.requestId || '—'}</PanelValue>
        </PanelField>

        {meetingUrl && (
          <PanelField>
            <PanelLabel>Meeting URL</PanelLabel>
            <PanelLink href={meetingUrl} target="_blank" rel="noopener noreferrer">
              {meetingUrl}
            </PanelLink>
          </PanelField>
        )}
      </PanelGrid>

      {participantEmails && participantEmails.length > 0 && (
        <PanelSection>
          <PanelSectionTitle>Participants ({participantEmails.length})</PanelSectionTitle>
          <ParticipantList>
            {participantEmails.map(email => (
              <ParticipantChip key={email}>{email}</ParticipantChip>
            ))}
          </ParticipantList>
        </PanelSection>
      )}
    </ExpandedPanel>
  );
}
